<script lang="ts">
	import { getSafeSrc } from '@repo/commons/utils'
	import { Avatar } from '@repo/commons/components'
	interface Props {
		/**
		 * UserInfo component that displays user details dynamically.
		 *
		 * @prop {Record<string, Record<string, string>>} row - Object containing user details.
		 * @prop {string} key - Key to access specific user data from `row`.
		 */
		row: Record<string, Record<string, string>>
		key: string
	}

	let { row, key }: Props = $props()

	console.log(`row: ${JSON.stringify(row)}, key: ${key}`)
	const imageUri = $derived(getSafeSrc(row[key].base64 ?? row[key].url, 'image'))

	/** Reactive data object containing user details. */
	const data = $derived({
		avatar: imageUri,
		name: getParams.name,
		secondaryText: getParams.secondaryText
	})
</script>

<div class="user-info">
	<div class="avatar-wrapper">
		<Avatar imageSrc={imageUri} fallback={row[key].name.charAt(0)} />
	</div>
	<div>
		<div class="name">{row[key].name}</div>
		<div class="secondary-text">{row[key].secondaryText}</div>
	</div>
</div>

<style>
	.user-info {
		display: flex;
		align-items: center;
		gap: 12px;
	}
	.avatar-wrapper {
		width: 48px;
		height: 48px;
	}
	.name {
		text-transform: capitalize;
		color: rgba(0, 22, 38, 0.9);
		font-family: 'Inter', sans-serif;
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		white-space: nowrap;
	}
	.secondary-text {
		text-transform: capitalize;
		color: rgba(0, 29, 51, 0.7);
		font-family: 'Inter', sans-serif;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
	}
</style>
